export { I18n } from '@atlassian/aui/src/js/aui/i18n';
